/**
 * Copies text: the Clipboard API first, then the older copy command (it
 * still works where the browser refuses clipboard-write for the site).
 * Resolves false when both were refused, so the caller can say so and show
 * the text to copy by hand; it never rejects.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* refused: the older way below */
  }
  if (typeof document === 'undefined') return false;
  const before = document.activeElement as HTMLElement | null;
  const area = document.createElement('textarea');
  try {
    area.value = text;
    area.setAttribute('readonly', '');
    area.setAttribute('aria-hidden', 'true');
    area.style.position = 'fixed';
    area.style.insetBlockStart = '0';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    return typeof document.execCommand === 'function' && document.execCommand('copy');
  } catch {
    return false;
  } finally {
    area.remove();
    before?.focus?.({ preventScroll: true });
  }
}
